<template>
  <div class="relative">
    <slot />
    <!--end::content-->

    <component :is="item.component" v-for="(item, index) of extend" :key="index" v-bind="bindProperties" />
    <!--end::extends-->
  </div>
</template>

<script>
export default {
  props: {
    extend: {
      type: Array,
      required: false,
      default: () => [],
    },
    scenes: {
      type: Array,
      required: true,
    },
  },
  computed: {
    bindProperties() {
      return {
        parent: this,
      }
    },
  },
}
</script>
